import { DataField, Space, Text, TextLoader } from '@procurify/ui'

import { useFormatTaxPercentage, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { TaxLabelTextStyled } from './styles/TaxDataFieldPresenterStyled'
import { useTaxDataFieldPresenter } from './useTaxDataFieldPresenter'

export interface ITaxDataFieldPresenterProps {
  id: number
  label?: string
}

export const TaxDataFieldPresenter = ({
  id,
  label,
}: ITaxDataFieldPresenterProps) => {
  const intl = useProcurifyIntl()
  const formatTaxPercentage = useFormatTaxPercentage()

  const {
    data: { tax },
    states: { showLoader },
  } = useTaxDataFieldPresenter({ id })

  return (
    <DataField label={label || intl.formatMessage(messages.fieldLabel)}>
      {showLoader && <TextLoader width={150} />}

      {!showLoader &&
        (tax ? (
          <Space direction='horizontal' size='xsmall' align='center'>
            <TaxLabelTextStyled>
              <Text autoMargin={false}>{tax.name}</Text>
            </TaxLabelTextStyled>
            <Text color='textSecondary'>
              {formatTaxPercentage(tax.percentage)}
            </Text>
          </Space>
        ) : (
          <Text color='textTertiary' italic>
            {intl.formatMessage(messages.noDefaultTaxSet)}
          </Text>
        ))}
    </DataField>
  )
}
